import { classes } from 'html-classes';
import type { ChangeEvent, JSX } from 'react';
import { useTranslation } from 'react-i18next';

import type { SortingFieldName, SortingOrder } from '~/api/Catalog';
import { company } from '~/company/Company';
import { MobileActionDialog as MobileActionDialogV3 } from '~/components/MobileActionDialogV3';
import {
  CIRCLEK_SORTING_OPTIONS,
  SORTING_OPTIONS,
} from '~/components/ProductSorting/constants';

import { Radio } from '../isolated/Radio';

import type { IMobileSortingProps } from './interfaces';
import styles from './MobileSorting.module.scss';

const MobileSorting = (props: IMobileSortingProps): JSX.Element | null => {
  const { className, open, onClose, value, onChange } = props;
  const MobileActionDialogCom = company.match({
    citydrinks: MobileActionDialogV3,
    default: MobileActionDialogV3,
  });

  const { t } = useTranslation();

  const options = (
    company.isReviewPanelHidden ? CIRCLEK_SORTING_OPTIONS : SORTING_OPTIONS
  ).map((v) => ({
    label: t(`sorting:${v}`),
    value: v,
  }));

  const onChangeValue = (e: ChangeEvent<HTMLInputElement>): void => {
    if (!onChange) {
      return;
    }

    const [field, order] = e.target.value.split('.') as [
      SortingFieldName,
      SortingOrder,
    ];

    onChange([field, order]);
  };

  return (
    <MobileActionDialogCom
      open={open}
      onClose={onClose}
      className={classes([styles.content, className])}
      contentHeight="386px"
      title={<h2 className={styles.title}>{t('sortBy')}</h2>} // TRANSLATE //
    >
      {options.map((item) => (
        <Radio
          className={styles.checkboxItem}
          key={item.value}
          value={item.value}
          checked={item.value.toString() === value}
          label={item.label}
          onChange={onChangeValue}
        />
      ))}
    </MobileActionDialogCom>
  );
};

export default MobileSorting;
